import { WISHLIST_SUB_TITLE } from '@components/utils/textVariables'
import { IMAGE_ASSET_BASE_URL } from '@framework/utils/constants'
import Image from 'next/legacy/image'
import Link from 'next/link'

const WishlistEmpty = () => {
  return (
    <div className="flex flex-col items-start justify-center w-full px-4 py-12 sm:items-center max-acc-container sm:px-0">
      <Image
        priority={true}
        blurDataURL={`${IMAGE_ASSET_BASE_URL}/icons/basket-no-item.svg`}
        placeholder="blur"
        src={`${IMAGE_ASSET_BASE_URL}/icons/basket-no-item.svg`}
        alt="no basket icon"
        className="m-92-img"
        width={92}
        height={96}
      />
      <div className="my-0 font-semibold text-secondary-full-opacity text-m-16 text-24">
        {WISHLIST_SUB_TITLE}
      </div>
      <p className="text-xs sm:text-sm text-primary opacity-60">
        Explore more and save items in your wishlist.{' '}
      </p>
      <div className="flex w-full mt-5 sm:flex-col">
        <Link
          href="/men/all"
          className="w-full flex items-center justify-center px-4 py-3 -mr-0.5 text-white bg-black border-2 border-black rounded-sm hover:bg-gray-800 hover:text-white sm:px-6 hover:border-gray-900"
        >
          Start Shopping
        </Link>
      </div>
    </div>
  )
}

export default WishlistEmpty
